import { render } from "./OrderCancelConfirm.vue?vue&type=template&id=4642c8cf&scoped=true"
import script from "./OrderCancelConfirm.vue?vue&type=script&lang=js"
export * from "./OrderCancelConfirm.vue?vue&type=script&lang=js"

import "./OrderCancelConfirm.vue?vue&type=style&index=0&id=4642c8cf&scoped=true&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4642c8cf"]])

export default __exports__